const H5pExternalDispatcherPopup = () => {
    document.addEventListener("DOMContentLoaded", function () {

        // Функция выхода из fullscreen (если видео развернуто)
        function exitFullscreenIfNeeded(callback) {
            if (document.fullscreenElement) {
                document.exitFullscreen()
                    .then(() => callback())
                    .catch(() => callback());
            } else {
                callback();
            }
        }

        if (window.H5P && H5P.externalDispatcher) {
            H5P.externalDispatcher.on('xAPI', function (event) {
                const s = event?.data?.statement;
                if (!s) return;

                // Только completed
                if (s.verb?.id !== 'http://adlnet.gov/expapi/verbs/completed') return;

                // Только Interactive Video
                const categories = s.context?.contextActivities?.category || [];
                const isInteractiveVideo = categories.some(cat =>
                    typeof cat.id === 'string' &&
                    cat.id.startsWith('http://h5p.org/libraries/H5P.InteractiveVideo-')
                );
                if (!isInteractiveVideo) return;

                const scaled = s.result?.score?.scaled || 0;

                const contentId = getH5PContentId(s.object?.id);
                if (!contentId) return;

                const popupBlock = document.querySelector(
                    `.rcPopupInteractiveVideo[data-id="${contentId}"]`
                );
                if (!popupBlock) return;

                let bColor, title, img, classPopup;

                if (scaled === 1) {
                    bColor = '#fff';
                    title = rcTranslate.passed_video;
                    img = rcTranslate.passed_video_img;
                    classPopup = 'passed';
                } else {
                    bColor = '#000';
                    title = rcTranslate.not_passed_video;
                    img = rcTranslate.not_passed_video_img;
                    classPopup = 'not-passed';
                }

                // 👉 Сначала выходим из fullscreen, потом показываем попап
                exitFullscreenIfNeeded(() => {
                    popupBlock.style.display = 'block';
                    popupBlock.style.backgroundColor = bColor;
                    popupBlock.style.zIndex = 9999;
                    popupBlock.classList.add(classPopup);

                    const imgEl = popupBlock.querySelector('#rcInteractiveVideo-img');
                    const titleEl = popupBlock.querySelector('#rcInteractiveVideo-title');
                    const linkEl = popupBlock.querySelector('#rcInteractiveVideo-link');

                    if (imgEl) imgEl.src = img;
                    if (titleEl) titleEl.textContent = title;
                    if (linkEl) linkEl.style.display = 'inline-block';
                });
            });
        }

        function getH5PContentId(objectId) {
            try {
                const url = new URL(objectId);
                return url.searchParams.get('id');
            } catch (e) {
                return null;
            }
        }

        // Закрытие попапа
        const closeButtons = document.querySelectorAll('#InteractiveVideo-popup-close');
        closeButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const popupBlock = btn.closest('.rcPopupInteractiveVideo');
                if (popupBlock) {
                    popupBlock.style.display = 'none';
                }
            });
        });

    });
};

export default H5pExternalDispatcherPopup;
